export default __webpack_public_path__ + "static/media/sparkcentral.7ef0e195.svg";